export const selectAllPromotions = (state: IGlobalState) => state.promotions.promotions
export const selectPromotionResponse = (state: IGlobalState) =>
  state.promotions.promotionResponse
export const selectPromotionId = (state: IGlobalState) => state.promotions.promotionId
export const selectPromotion = (state: IGlobalState) => state.promotions.promotion
